import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';

const client = axios.create({ baseURL: API_BASE });

client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export async function getAgenda({ desde, hasta } = {}) {
  const { data } = await client.get('/agenda', { params: { desde, hasta } });
  return data;
}

export async function crearItems(items) {
  const { data } = await client.post('/agenda', Array.isArray(items) ? { items } : items);
  return data;
}

export async function actualizarItem(id, cambios) {
  const { data } = await client.patch(`/agenda/${id}`, cambios);
  return data;
}

export async function borrarItem(id) {
  const { data } = await client.delete(`/agenda/${id}`);
  return data;
}

// La IA arma varios días: puede tardar.
export async function generarPlan({ dias, desde } = {}) {
  const { data } = await client.post('/agenda/generar', { dias, desde }, { timeout: 180000 });
  return data;
}

const agendaService = { getAgenda, crearItems, actualizarItem, borrarItem, generarPlan };
export default agendaService;
